import { useUser } from '@/features/account/services/User/hooks'
import { useFeatureFlags } from '@/features/shared/services/FeatureFlags/useFeatureFlags'
import { useExperiment } from '@/features/shared/services/Experiments/hooks'
import { ExperimentType } from '@shared/types/experiments'

export const useIsShoppingAgentEnabled = (): boolean => {
  const user = useUser()
  const { flags } = useFeatureFlags()
  const { active: gecxCartBuilderEnabled } = useExperiment(
    ExperimentType.GECX_CART_BUILDER_INTERNAL,
    { autoTrack: true },
  )

  return (flags.gecx_shopping_agent || gecxCartBuilderEnabled) && !!user?.id && !!user.store
}
